module.exports = __webpack_public_path__ + "img/l1.5e959d6c.png";